import { Checkbox, Stack } from "@mui/material";
import { GridColDef } from "@mui/x-data-grid";
import { AppTable } from "components/molecules";
import { TableHelper } from "helpers";
import { usePaginationRequest } from "hooks";
import { IGetPeriodCycleCountDetailSplitRequest } from "model";
import { IDeliveryProgress } from "model/LoadingOrder/IDeliveryProgress";
import { useState } from "react";
import { LoadingOrderActions } from "redux/actions";
import { useAppSelector } from "redux/configurations/reduxHooks";
import { CycleCountApiService } from "services";
import { CURRENT_PAGE_SIZE, FIRST_PAGE } from "utils/Const";
import { I18nTranslator, translations } from "utils/i18n";

interface IProductListProps {
  id: string;
}
const CheckedLocationList = (props: IProductListProps) => {
  const { id } = props;
  const action = useAppSelector(
    (state) => state.LoadingOrderReducer.pallet.action
  );

  const [refresh, setRefresh] = useState(false);

  const [request, setRequest] =
    useState<IGetPeriodCycleCountDetailSplitRequest>({
      documentNbr: "",
      cycleCountPeriodID: props.id,
      pageNumber: FIRST_PAGE,
      pageSize: CURRENT_PAGE_SIZE,
    });

  const { loading, result } = usePaginationRequest<
    IGetPeriodCycleCountDetailSplitRequest,
    any[]
  >(
    request,
    CycleCountApiService.getPeriodicCycleCountDetailSplit,
    [],
    {
      refresh: refresh,
    },
    () => {
      setRefresh(false);
    }
  );

  const _handleChangePage = (pageNumber: number) => {
    setRequest({
      ...request,
      pageNumber,
    });
  };

  const _handleSearch = (searchText: string) => {
    setRequest({
      ...request,
      searchText,
    });
  };

  const _handlePageSizeChange = (pageSize: number) => {
    setRequest({ ...request, pageSize: pageSize });
  };

  const COLUMNS: GridColDef[] = [
    TableHelper.renderSTT(),
    TableHelper.createCell({
      field: "zoneName",
      headerName: I18nTranslator(translations.masterData.zoneName),
      size: "small",
      align: "left",
    }),
    TableHelper.createCell({
      field: "locationName",
      headerName: I18nTranslator(translations.masterData.locationName),
      size: "small",
      align: "left",
    }),

    TableHelper.createCell({
      field: "palletCode",
      headerName: I18nTranslator(translations.receive.palletCode),
      size: "small",
      align: "left",
    }),
    TableHelper.createCell({
      field: "productLot",
      headerName: I18nTranslator(translations.receive.productLot),
      size: "small",
      align: "left",
    }),
    TableHelper.createCell({
      field: "productCode",
      headerName: I18nTranslator(translations.receive.productCode),
      size: "small",
      align: "left",
    }),
    TableHelper.createCell({
      field: "productDescription",
      headerName: I18nTranslator(translations.receive.productName),
      size: "large",
    }),
    TableHelper.createCell({
      field: "actualQuantity",
      headerName: I18nTranslator(
        translations.periodicCycleCount.actualQuantity
      ),
      size: "small",
      align: "right",
    }),
    TableHelper.createCell({
      field: "verifyQuantity",
      headerName: I18nTranslator(
        translations.periodicCycleCount.actualCheckedQuantity
      ),
      size: "small",
      align: "right",
    }),
    TableHelper.createCell({
      field: "verifyLocation",
      headerName: I18nTranslator(
        translations.periodicCycleCount.actualLocation
      ),
      size: "small",
      align: "right",
    }),
    TableHelper.createCell({
      field: "reasonName",
      headerName: I18nTranslator(translations.periodicCycleCount.reason),
      size: "small",
    }),
    TableHelper.createCell({
      field: "userName",
      headerName: I18nTranslator(translations.periodicCycleCount.user),
      size: "medium",
    }),
    TableHelper.createCell({
      field: "note",
      headerName: I18nTranslator(translations.periodicCycleCount.note),
      size: "full",
    }),
  ];
  return (
    <div>
      <AppTable<IDeliveryProgress>
        loading={loading}
        data={result}
        columns={COLUMNS}
        hideAddNew
        onSearch={_handleSearch}
        searchPlaceholder={I18nTranslator(
          translations.placeholder.searchDeliveryProgress
        )}
        onChangePage={_handleChangePage}
        removeActionColumn
        hideHeader
        defaultHeaderTable={230}
        onPageSizeChange={_handlePageSizeChange}
      />
    </div>
  );
};

export default CheckedLocationList;
